module.exports = __webpack_public_path__ + "img/1532706899.a7bc2f57.jpg";